const colors = {
    Normal: "A8A878",
    Fire: "F08030",
    Water: "6890F0",
    Grass: "78C850",
    Electric: "F8D030",
    Ice: "98D8D8",
    Ground: "E0C068",
    Flying: "A890F0",
    Poison: "A040A0",
    Fighting: "C03028",
    Psychic: "F85888",
    Dark: "705848",
    Rock: "B8A038",
    Bug: "A8B820",
    Ghost: "705898",
    Steel: "B8B8D0",
    Dragon: "7038F8",
    Fairy: "FFAEC9",
    Unknown: "1C9C88",
    Shadow: "7E0ED6"
}

//const previous = {
//    Fire : "F7912F",
//    Grass: "90E77E",
//    Water: "2FD8D1",
//    Psychic: "F439A7",
//    Bug: "9FC788",
//    Dark: "918987",
//    Rock: "C59D45",
//  
//    /*dragon {
//        arriba: #6B98F6
//        abajo: #F56E6B
//    }*/
//  
//    /*ground {
//        arriba: #DEDF08
//        abajo: #C89E49
//    }*/
//  
//    Ice: "2fd8d1",
//    Steel: "B9B7CF",
//    Electric: "DFDF06",
//    Normal: "B8B7A6",
//  
//    /*Flying: {
//        arriba: #59C7EC
//        abajo: #B8B7A6
//    }*/
//  
//    Ghost: "A570F9",
//    Poison: "DE90F8",
//    Fighting: "FF7372"
//}

export default colors